import { Grid, InputAdornment, TextField } from '@mui/material'
import Button from '@mui/material/Button'
import SearchIcon from '@mui/icons-material/Search'

import { EDistributionChannelType } from '../../../../../types/distribution-channel'
import ClearIcon from '@mui/icons-material/Clear'
import DateRangePicker from '../../../../../components/DateRangePicker'


export interface IFilterMapped {
  page?: number;
  perPage?: number;
  search?: string;
  startDate?: string;
  endDate?: string;
}

interface FilterGroupProps {
  filter: IFilterMapped
  onFilterChange: (filter: IFilterMapped) => void;
  onSearch: (filter: IFilterMapped) => void;
}

const menuItemsType = [
  {
    label: 'ทั้งหมด',
    value: undefined,
  },
  {
    label: 'Facebook',
    value: EDistributionChannelType.FACEBOOK,
  },
  {
    label: 'Tiktok',
    value: EDistributionChannelType.TIKTOK,
  },
  {
    label: 'Instagram',
    value: EDistributionChannelType.INSTAGRAM,
  },
  {
    label: 'Shopee',
    value: EDistributionChannelType.SHOPEE,
  },
  {
    label: 'Lazada',
    value: EDistributionChannelType.LAZADA,
  },
  {
    label: 'อื่นๆ',
    value: EDistributionChannelType.ETC,
  },
]

const AddressFilter = ({ filter, onFilterChange, onSearch }: FilterGroupProps) => {
  const { page, perPage, search, startDate, endDate } = filter

  return (
    <Grid container spacing={2} mb={2}>
      <Grid item xs={12} lg={12}>
        <TextField
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          label={'ค้นหาจากที่อยู่'}
          fullWidth
          id="search"
          name="search"
          variant="filled"
          value={search ?? ""}
          onChange={(e) => onFilterChange({ ...filter, search: e.target.value })}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <DateRangePicker
          startDate={startDate}
          endDate={endDate}
          onChange={(startDate, endDate) => {
            onFilterChange({ ...filter, startDate, endDate })
          }}
        />
      </Grid>
      <Grid item xs={12} lg={4}>
        <Button
          color="primary"
          size="large"
          fullWidth
          variant="contained"
          startIcon={<SearchIcon />}
          onClick={() => onSearch(filter)}
          sx={{ height: '100%' }}
        >
          ค้นหา
        </Button>
      </Grid>
      <Grid item xs={4} lg={2}>
        <Button
          color="inherit"
          size="large"
          fullWidth
          variant="contained"
          startIcon={<ClearIcon />}
          onClick={() => {
            onFilterChange({
              page,
              perPage,
              search: undefined,
              startDate: undefined,
              endDate: undefined,
            })
            onSearch({
              page,
              perPage,
              search: undefined,
              startDate: undefined,
              endDate: undefined,
            })
          }}
          sx={{ height: '100%' }}
        >
          รีเซ็ต
        </Button>
      </Grid>
    </Grid>
  )
}

export default AddressFilter
